import GradientBorderRadius from "@/ui/gradient-border-radius";
import OrdersHeader from "./orders-header";
import OrdersTable from "./orders-table";
import { OrdersFilterProvider } from "@/providers/orders-filter/orders-filter";
import { useState } from "react";
import { TokenValueToggleView } from "@/features/token-value-toggle/token-value-toggle";

const OrdersPage = () => {
  const [selectedTokenValue, setSelectedTokenValue] =
    useState<TokenValueToggleView>("sol");

  return (
    <OrdersFilterProvider>
      <GradientBorderRadius
        background="section-gradient"
        overflow
        className="flex-1 flex w-full"
      >
        <div className="flex-1 flex flex-col w-full gap-[0.625rem] pt-[0.625rem]">
          <OrdersHeader
            selectedView={selectedTokenValue}
            setSelectedView={setSelectedTokenValue}
          />
          <OrdersTable selectedView={selectedTokenValue} />
        </div>
      </GradientBorderRadius>
    </OrdersFilterProvider>
  );
};

export default OrdersPage;
